import { createApp } from 'vue'
import App from '@base/App.vue'
import router from '@custom/router'
import store from '@custom/store'



import common from '@base/tools/common'
import custom from '@custom/tools/custom'




import DisplayField from '@base/components/Formkit/Display'
import WysiwygField from '@base/components/Formkit/Wysiwyg'
import WysiwygTiptapField from '@base/components/Formkit/Wysiwyg_tiptap'
import RepeaterField from '@base/components/Formkit/Repeater'
import TreeField from '@base/components/Formkit/Tree'
import FileField from '@base/components/Formkit/File'
import AutoCompleteField from '@base/components/Formkit/Autocomplete'
import AutoCompleteMultipleField from '@base/components/Formkit/AutocompleteMultiple'
import FileBrowser from '@base/components/Formkit/FileBrowser'
import Editor from '@tinymce/tinymce-vue'

import mitt from 'mitt'

// FORMKIT
import { plugin, defaultConfig, createInput } from '@formkit/vue'
import { FormKitSchema } from '@formkit/vue'
import { en,nl } from '@formkit/i18n'
import { applicationIcons } from '@formkit/icons'


import moveLabelPlugin from '@base/tools/moveLabelPlugin'
import addWrapperPlugin from '@base/tools/addWrapperPlugin'
import { text } from '@base/inputs/text'
//import { select } from '@base/inputs/select'
import { checkbox } from '@base/inputs/checkbox'


//import '@formkit/themes/genesis'
//import '@formkit/pro/genesis'

//import { plugin, defaultConfig } from '@formkit/vue'
//import { createProPlugin, inputs } from '@formkit/pro'

//const pro = createProPlugin('fk-2a617d357', inputs)
//app.use(plugin, defaultConfig({ plugins: [pro] }))






import '@base/assets/css/layout.css';
import '@custom/assets/css/custom.css';


// import DropZone from 'dropzone-vue';

// // optionally import default styles
// import 'dropzone-vue/dist/dropzone-vue.common.css';

const emitter = mitt()

const app = createApp(App)

app.config.globalProperties.emitter = emitter

app.mixin(common);
app.mixin(custom);
app.use(store);
app.use(router);
//app.use(DropZone);


// import { SetupCalendar } from 'v-calendar';


// // Setup plugin for defaults or `$screens` (optional)
// app.use(SetupCalendar, {})



// Define your FormKit global config/plugins here:
app.use(
  plugin,
  defaultConfig({
    // Define additional locales
    locales: { en,nl },
    // Define the active locale
    locale: 'nl',
    //iconLoaderUrl: (iconName) => `https://cdn.jsdelivr.net/npm/@fortawesome/fontawesome-free/svgs/regular/${iconName}.svg`,
    iconLoaderUrl: (iconName) => `/fa/svgs/regular/${iconName}.svg`,
    // icons: {
    //   ...applicationIcons
    // },
    
    inputs: {
      display: createInput(DisplayField, {
        //props: ['digits'],
      }),
      // wysiwyg: createInput(WysiwygField, {
      // }),
      wysiwyg: createInput(WysiwygTiptapField, {

      }),
      repeater: createInput(RepeaterField, {
        //props: ['digits'],
      }),
      tree: createInput(TreeField, {
        //props: ['digits'],
      }),
      file: createInput(FileField, {
        //props: ['digits'],
      }),
      autocomplete: createInput(AutoCompleteField, {
        //props: ['digits'],
      }),
      autocomplete_multiple: createInput(AutoCompleteMultipleField, {
        //props: ['digits'],
      }),
      filebrowser: createInput(FileBrowser, {
        //props: ['digits'],
      }),
      editor:Editor,
      //checkbox
      //text
      //select
    },
    plugins: [moveLabelPlugin]
}));


app.config.globalProperties.$filters = {
  pathControllerAlias(controller) {
    switch(controller) {
      case 'participants': return 'students'; break;
      default: return controller;
    }
  },
  nl2br(str) {
    if (typeof str === 'undefined' || str === null) {
      return '';
    }
    var breakTag = '<br />';
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
  },
  formatPrice(value) {
    if (!value) return '-';
    value = parseFloat(value).toFixed(2).toString();
    var e = value.split('.');
    
    if(e[0].length>3 && e[0][0]!='-') { 
      e[0] = e[0].substring(0,e[0].length-3)+'.'+e[0].substring(e[0].length-3,e[0].length);
    }
    if (e.length==2) {
      return '€ '+e[0]+','+e[1];
    }
    else {
      return '€ '+e[0]+',00';
    }
  },
  formatDate(value) {
    if (!value) return '-';
    var e = value.split(' ');
    if (e.length==2) {
      var e2 = e[0].split('-');
      var e3 = e[1].split(':');
      return e2[2]+'-'+e2[1]+'-'+e2[0]+', '+e3[0]+':'+e3[1]+' uur';
    }
    else if (e.length==1) {
      var e2 = value.split('-');
      return e2[2]+'-'+e2[1]+'-'+e2[0];
    }
    else {
      //console.log(e.length)
      return '-';
    }
    
  }
}

app.mount('#app')



//
//App.mixin(common);

// createApp(App).mixin(common).use(plugin, defaultConfig({
//     plugins: [moveLabelPlugin]
//   })).use(store).use(router).mount('#app')

